import messages from './../iban-calculator-lang.json';
import { clipboardMixin } from '../../../common/js/clipboard/clipboard-mixin';
import { TYPES } from '../iban-calculator';
export default {
	props: {
		iban: {
			required: true
		},
		submittedAccountNumber: {
			required: true
		},
		type: {
			type: String
		}
	},
	mixins: [clipboardMixin],
	i18n: { messages },
	computed: {
		TYPES: () => TYPES
	}
};
